module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/live.20250322.gif";